import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ClipLoader } from 'react-spinners';
import { FaSave, FaTrash } from 'react-icons/fa';
import { fmt3, listTotal } from './reverseHelpers';

/**
 * @param {{
 *   list: object[], error: string, highlightIds: string[], reverseDate: Date|null, saving: boolean,
 *   onRemove: (recordId: string) => void, onDateChange: (d: Date|null) => void, onSave: () => void
 * }} props
 */
const ReversalListGrid = ({ list, error, highlightIds, reverseDate, saving, onRemove, onDateChange, onSave }) => {
    const th = { whiteSpace: 'nowrap' };
    return (
        <div className="cost-center-section mt-3">
            <div className="d-flex slide-header"><div className="param-label pt-1">Reversal List</div></div>
            {error && <div className="alert alert-danger mb-0" role="alert">{error}</div>}
            <div className="table-container" style={{ overflowX: 'auto', maxHeight: 300, overflowY: 'auto' }}>
                <table className="table table-bordered mb-0">
                    <thead className="dynoTable">
                        <tr>
                            <th style={th}>Lease No</th>
                            <th style={th}>Receipt No</th>
                            <th style={th}>Installment</th>
                            <th style={th}>Property</th>
                            <th style={th}>Unit</th>
                            <th style={th}>Tenant</th>
                            <th style={th}>Transaction Type</th>
                            <th style={{ ...th, textAlign: 'right' }}>Amount</th>
                            <th style={th}>Remarks</th>
                            <th style={th}>Refund Account</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {list.length === 0 && (
                            <tr><td colSpan={11} className="text-center text-muted p-3">No receipts added.</td></tr>
                        )}
                        {list.map((row) => (
                            <tr key={row.recordId} className={highlightIds.includes(row.recordId) ? 'table-danger' : ''}>
                                <td>{row.leaseNo}</td>
                                <td>{row.receiptNo}</td>
                                <td>{row.installmentDesc}</td>
                                <td>{row.propertyName}</td>
                                <td>{row.unitNo}</td>
                                <td>{row.tenantName}</td>
                                <td>{row.transactionType}</td>
                                <td style={{ textAlign: 'right' }}>{fmt3(row.amount)}</td>
                                <td>{row.remarks}</td>
                                <td>{row.refundAccountName}</td>
                                <td>
                                    <button type="button" className="mainbtnRed" disabled={saving} onClick={() => onRemove(row.recordId)}>
                                        <FaTrash className="center mt-1 mx-1" /><div>Remove</div>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={7} className="text-end fw-bold">Total:</td>
                            <td className="text-end fw-bold">{fmt3(listTotal(list))}</td>
                            <td colSpan={3} />
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div className="border-box2 p-3 d-flex align-items-center gap-3">
                <label className="form-label mb-0">Transaction Date</label>
                <div style={{ width: 180 }}>
                    <DatePicker
                        className="p-2 form-control"
                        dateFormat="dd-MMM-yyyy"
                        selected={reverseDate}
                        disabled={saving}
                        onChange={onDateChange}
                    />
                </div>
                <button type="button" className="mainbtn" disabled={saving || list.length === 0} onClick={onSave}>
                    {saving ? <ClipLoader color="#ffffff" size={20} /> : <><FaSave className="center mt-1 mx-2" /><div>Save</div></>}
                </button>
            </div>
        </div>
    );
};

export default ReversalListGrid;
